export const VariantStatuses = {
  DEFAULT: 'DEFAULT',
  VARIANT: 'VARIANT'
};